import React from 'react';
//mui
import { Grid } from '@mui/material';
//widgets
import { AppNavigationBox } from './widgets';
//i18n
import i18n from 'i18';
import {
    EmptyWalletTransparentBulkIcon,
    Shop1BulkIcon,
    ScanBarcodeTranspBulkIcon
} from '../../icons-lib/bulkIcons';

const NavigationBoxSection = ({ navigate }) => (
    <>
        <Grid item xs={12} sm={6} md={4}>
            <AppNavigationBox
                title={i18n.t('buttons.wallets')}
                startIcon={<EmptyWalletTransparentBulkIcon />}
                handleClick={() => navigate('/app/wallets')}
            />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
            <AppNavigationBox
                title={i18n.t('buttons.partnersShop')}
                startIcon={<Shop1BulkIcon />}
                handleClick={() => navigate('/app/merchants')}
            />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
            <AppNavigationBox
                title={i18n.t('buttons.codesNCoupons')}
                startIcon={<ScanBarcodeTranspBulkIcon />}
                handleClick={() => navigate('/app/transaction-coupons')}
            />
        </Grid>
    </>
);

export default NavigationBoxSection;
